/**
 * TranscriptTab — tab panel wrapper for the transcript content.
 *
 * The transcript rendering machinery (TranscriptView, TurnRow, etc.) lives in
 * MeetingReview.tsx and is passed in as children. This component owns only the
 * tab-panel frame and the no-transcript states.
 */

import { type ReactNode } from "react";

interface Props {
  /** The full TranscriptView element (or a placeholder) from the orchestrator. */
  children: ReactNode;
}

export function TranscriptTab({ children }: Props) {
  return (
    <div
      role="tabpanel"
      aria-labelledby="tab-transcript"
      data-testid="transcript-tab"
      style={{ flex: 1, minWidth: 0 }}
    >
      {children}
    </div>
  );
}
